<template>
  <div class="flex justify-center">
    <div class="flex flex-row justify-center">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'step-list',
  props: {
    activeStep: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      steps: []
    }
  },
  mounted () {

    const steps = this.$children

    for (let i = 0; i < steps.length; i++) {
      steps[i].index = i
      if (this.activeStep === i) {
        steps[i].isActive = true
      }
    }

    if (steps.length > 0) {
      steps[steps.length - 1].isLast = true
    }

  }
}
</script>

